import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationServiceService } from './../../../../../../../services/notification-service/notification-service.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { ContenedoresService } from './../../../../../../../services/API/contenedores/contenedores.service';

@Component({
    selector: 'app-view-contenedor',
    templateUrl: './view-contenedor.component.html',
    styleUrls: ['./view-contenedor.component.css'],
    standalone: false
})
export class ViewContenedorComponent implements OnInit {

  contenedor: number = null;
  showProgressBar: boolean = true;
  form: UntypedFormGroup;
  matricula: string = "";
  matricula_old: string = "";
  medidas: string = "";
  estado: string = "activo";
  tipos: any = [];
  tiposSearch: any = [];
  tipo: string = '-1';
  observaciones: string = "";

  constructor(private route: ActivatedRoute, public router: Router, private notificationService: NotificationServiceService, private fb: UntypedFormBuilder, private contenedoresService: ContenedoresService) { }

  ngOnInit(): void {
    this.contenedor = parseInt(this.route.snapshot.paramMap.get("id"));
    if(this.contenedor === null){
      this.back();
    }
    this.getTiposContenedores();
    this.prepareForm();
  }

  getTiposContenedores() {
    this.showProgressBar = true;
    this.contenedoresService.getTiposContenedores().subscribe(result => {
      this.showProgressBar = false;
      this.tipos = result;
      this.tiposSearch = this.tipos;
      this.getContenedorInfo();
    });
  }

  getContenedorInfo(){
    this.showProgressBar = true;
    this.contenedoresService.getContenedor(this.contenedor).subscribe(result => {
      this.showProgressBar = false;
      this.matricula = result[0]['matricula'];
      this.matricula_old = result[0]['matricula_old'];
      this.medidas = result[0]['medidas'];
      this.estado = result[0]['estado'];
      this.tipo = result[0]['tipo'];
      this.observaciones = result[0]['observaciones'];
      this.prepareForm();
    });
  }

  save() {
    const {value, valid} = this.form;
    if(valid){
      this.showProgressBar = true;
      this.contenedoresService.editContenedor(this.contenedor, value["matricula"], value["matricula_old"], value["medidas"], value["tipo"], value["estado"], value["observaciones"]).subscribe(() => {
        this.notificationService.openSnackBar("Contenedor modificado correctamente!");
        this.showProgressBar = false;
        this.getContenedorInfo();
      });
    }
  }

  prepareForm(){
    this.form = this.fb.group({
      matricula: [this.matricula, [Validators.required, Validators.minLength(1), Validators.maxLength(32)]],
      matricula_old: [this.matricula_old, [Validators.maxLength(32)]],
      medidas: [this.medidas, [Validators.maxLength(64)]],
      observaciones: [this.observaciones, [Validators.maxLength(256)]],
      estado: [this.estado, [Validators.required]],
      tipo: [this.tipo, [Validators.required]],
    });
  }

  back(){
    this.router.navigateByUrl('/dashboard/contenedores-adm');
  }

  filterSelect_Tipos(value: string) { 
    this.tiposSearch = this.tipos.filter(option => option['nombre'].toLowerCase().includes(value.toLowerCase()));
  }

}
